import Reports from "../components/views/reports/reports.vue";
import Dashboard from "../components/views/dashboard/dashboard.vue";
import Visitors from "../components/views/visitors/visitors.vue";
import Visitors_security from "../components/views/visitors_security/visitors_security.vue";
import Offices from "../components/views/offices/offices.vue";
import Office_view from "../components/views/offices/view_office/view_office.vue";
import Alerts from "../components/views/alerts/alerts.vue";
import Settings from "../components/views/settings/settings.vue";
import Employees from "../components/views/employees/employees.vue";
import Health_declaration from "../components/views/health_declaration/health_declaration.vue";
import Employee_view from "../components/views/employees/view_employee/view_employee.vue";

import Xvapp from "../components/layout/xvapp/xvapp.vue";
import Login from "../components/layout/login/login.vue";
import Signup from "../components/layout/signup/signup.vue";

import Login_G from "../components/layout/login-g/login.vue";
import Dashboard_G from "../components/views-g/dashboard/dashboard.vue";
import Hospitals_G from "../components/views-g/hospitals/hospitals.vue";
import Hospital_view_G from "../components/views-g/hospitals/view_hospital/view_hospital.vue";
import Testing_center_G from "../components/views-g/testing_centers/testing_center.vue";
import Testing_center_view_G from "../components/views-g/testing_centers/view_testing_center/view_testing_center.vue";
import Quaratine_facilities_G from "../components/views-g/quarantine_facilities/quarantine_facilities.vue";
import Quaratine_facilities_view_G from "../components//views-g/quarantine_facilities/view_quarantine/view_quarantine.vue";
import Citizens_G from "../components/views-g/citizens/citizens";
import Citizens_view_G from "../components/views-g/citizens/view_citizen/view_citizens.vue";
import Alerts_G from "../components/views-g/alerts/alerts.vue";
import Cases_G from "../components/views-g/cases/cases.vue";

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/xv-admin",
    redirect: "/xv-admin/dashboard"
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    props: true
  },

  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    props: true
  },
  {
    path: "/xv-admin",
    name: "Xvapp",
    component: Xvapp,
    props: true,
    children: [
      {
        path: "reports",
        name: "Reports",
        component: Reports,
        props: true
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        props: true
      },
      {
        path: "visitors",
        name: "Visitors",
        component: Visitors,
        props: true
      },
      {
        path: "visitors_security",
        name: "Visitors_security",
        component: Visitors_security,
        props: true
      },
      {
        path: "offices",
        name: "Offices",
        component: Offices,
        props: true
      },
      {
        path: "offices:id",
        name: "Office_view",
        component: Office_view,
        props: true
      },
      {
        path: "alerts",
        name: "Alerts",
        component: Alerts,
        props: true
      },
      {
        path: "settings",
        name: "Settings",
        component: Settings,
        props: true
      },
      {
        path: "employees",
        name: "Employees",
        component: Employees,
        props: true
      },
      {
        path: "employee:id",
        name: "Employee_view",
        component: Employee_view,
        props: true
      },
      {
        path: "health_declaration",
        name: "Health_declaration",
        component: Health_declaration,
        props: true
      }
    ]
  },
  {
    path: "/login-g",
    name: "Login_G",
    component: Login_G,
    props: true
  },
  {
    path: "/xv-admin-g",
    redirect: "/xv-admin-g/dashboard"
  },
  {
    path: "/xv-admin-g",
    name: "Xvapp_G",
    component: Xvapp,
    props: true,
    children: [
      {
        path: "dashboard",
        name: "Dashboard_G",
        component: Dashboard_G,
        props: true
      },
      {
        path: "hospitals",
        name: "Hospitals_G",
        component: Hospitals_G,
        props: true
      },
      {
        path: "hospitals:id",
        name: "Hospital_view_G",
        component: Hospital_view_G,
        props: true
      },
      {
        path: "testing_centers",
        name: "Testing_center_G",
        component: Testing_center_G,
        props: true
      },
      {
        path: "testing_centers:id",
        name: "Testing_center_view_G",
        component: Testing_center_view_G,
        props: true
      },
      {
        path: "Quarantine_facilities",
        name: "Quaratine_facilities_G",
        component: Quaratine_facilities_G,
        props: true
      },
      {
        path: "Quarantine_facilities:id",
        name: "Quaratine_facilities_view_G",
        component: Quaratine_facilities_view_G,
        props: true
      },
      {
        path: "citizens",
        name: "citizens_G",
        component: Citizens_G,
        props: true
      },
      {
        path: "citizens:id",
        name: "Citizens_view_G",
        component: Citizens_view_G,
        props: true
      },
      {
        path: "alerts",
        name: "Alerts_G",
        component: Alerts_G,
        props: true
      },
      {
        path: "cases",
        name: "Cases_G",
        component: Cases_G,
        props: true
      },

    ]
  }
];
export default routes;
